/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RedemptionLimitFrequencyPeriod = {
    EVER: 'EVER',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    unknown_default_open_api: '11184809'
} as const;
export type RedemptionLimitFrequencyPeriod = typeof RedemptionLimitFrequencyPeriod[keyof typeof RedemptionLimitFrequencyPeriod];


export function instanceOfRedemptionLimitFrequencyPeriod(value: any): boolean {
    for (const key in RedemptionLimitFrequencyPeriod) {
        if (Object.prototype.hasOwnProperty.call(RedemptionLimitFrequencyPeriod, key)) {
            if (RedemptionLimitFrequencyPeriod[key as keyof typeof RedemptionLimitFrequencyPeriod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RedemptionLimitFrequencyPeriodFromJSON(json: any): RedemptionLimitFrequencyPeriod {
    return RedemptionLimitFrequencyPeriodFromJSONTyped(json, false);
}

export function RedemptionLimitFrequencyPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedemptionLimitFrequencyPeriod {
    return json as RedemptionLimitFrequencyPeriod;
}

export function RedemptionLimitFrequencyPeriodToJSON(value?: RedemptionLimitFrequencyPeriod | null): any {
    return value as any;
}

